import { Button, Card, Form, Input, Space } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from '../../../components/form-item'
import useForm from '../../../hooks/use-form'
import { useStoreCampaignColumn } from '../../hooks'
import { useStoreCompanyColumn } from '../../../company/hooks'

export function AddColumnColumn({ campaignId, companyId }: { campaignId?: string; companyId?: string }) {
    const [adding, setAdding] = useState(false)

    return (
        <Card
            size="small"
            className="min-w-[300px] cursor-pointer"
            onClick={() => setAdding(true)}
        >
            <Body
                adding={adding}
                campaignId={campaignId}
                companyId={companyId}
                onCancel={() => {
                    setAdding(false)
                }}
            />
        </Card>
    )
}

export function Body({
    adding,
    onCancel,
    campaignId,
    companyId,
}: {
    adding: boolean
    onCancel?: () => void
    campaignId?: string
    companyId?: string
}) {
    const { t } = useTranslation()

    const campaignMutation = useStoreCampaignColumn(campaignId!)
    const companyMutation = useStoreCompanyColumn(companyId!)
    const mutation = campaignId ? campaignMutation : companyMutation

    const formProps = useForm({
        mutation,
        onSuccess() {
            formProps.form.resetFields()
            onCancel?.()
        },
    })

    if (!adding) {
        return (
            <Space>
                <PlusOutlined />
                {t('Add another column')}
            </Space>
        )
    }

    return (
        <Form {...formProps}>
            <FormItem
                name="name"
                className="mb-2"
            >
                <Input />
            </FormItem>
            <Space>
                <Button
                    type="primary"
                    htmlType="submit"
                >
                    {t('Save')}
                </Button>
                <Button
                    onClick={(event) => {
                        event.stopPropagation()
                        formProps.form.resetFields()
                        onCancel?.()
                    }}
                >
                    {t('Cancel')}
                </Button>
            </Space>
        </Form>
    )
}
